import { useContext } from 'react';

import type { DropdownContextType } from '~/components/Dropdown/contexts/DropdownContext';
import { DropdownContext } from '~/components/Dropdown/contexts/DropdownContext';

export function useDropdownContext<T extends string>(): DropdownContextType<T> {
  const context = useContext<DropdownContextType<T> | null>(DropdownContext);

  if (!context) {
    throw new Error(
      'useDropdownContext must be used within a DropdownContextProvider',
    );
  }

  return context;
}
